// Kept in sync with the `category` check constraint in cc-backend/sql/schema.sql
// and the CATEGORIES list in cc-backend/src/controllers/listings.controller.js.
// Listed locally (rather than always fetched) so filter UIs render instantly;
// the marketplace still calls GET /api/listings/meta/categories as the
// source of truth and falls back to this list if that call fails.
export const CATEGORIES = [
  'Auto Parts',
  'Electronics',
  'Textiles',
  'FMCG',
  'Hardware',
  'Furniture',
  'Industrial',
  'Packaging',
  'Stationery',
  'Other',
];

// Kept in sync with the `condition` check constraint in cc-backend/sql/schema.sql
export const CONDITIONS = ['New', 'Like New', 'Open Box', 'Refurbished', 'Used / Surplus'];
